import { crudMdActions } from "@/services/crud-md-actions";

const name = "coupons";

export default {
  name,
  ...crudMdActions(name),
};
